<script>
export default {
    name: "TheatreBilling",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {
        procedure: Object,
    },

    components: {
        "billable-form": () => import('./tabs/Billables.vue'),
        "non-billable-form": () => import('./tabs/NonBillables.vue'),
    },

}
</script>
<template>
<div class="flex flex-wrap mt-1">
    <ul class="flex border-b border-gray-500 w-full">
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=0" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
            :class="active===0 ? activeClass : inActiveClass">Billables</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=1"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
            :class="active===1 ? activeClass : inActiveClass">Non-Billables</a>
      </li>
    </ul>
    <div class="flex-1" v-if="active===0">
        <billable-form :procedure="procedure" />
    </div>
    <div class="flex-1" v-if="active===1">
        <non-billable-form />
    </div>
</div>
</template>